import {
	Inject,
} from '@angular/core';
import {
	Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot,
} from '@angular/router';

import { Observable, of } from 'rxjs';
import { KeyValuePair } from '../../classes/key-value-pair';

export abstract class MediatorServiceBase<I, T> implements Resolve<T> {
	abstract create(I): T;

	constructor(
		@Inject('SESSION_STORAGE') protected sessionStorage: Storage,
		protected key: string
	) {
		// alert('MediatorServiceBase ctor.');
	}

	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<T> {
		let result: Observable<T> = null;
		const key = +route.paramMap.get(this.key);
		result = this.get(key);

		return result;
	}

	push(ob: T, key?: number): number {
		if (undefined === key || null === key) {
			key = Date.now();
		}
		const kvp = new KeyValuePair<number, T>(key, ob);

		if (this.sessionStorage) {
			this.sessionStorage.setItem(key.toString(), JSON.stringify(ob));
		}
		return key;
	}

	get(id: number): Observable<T> {
		let observable: Observable<T>;
		let result: T;
		if (this.sessionStorage) {
			const json = this.sessionStorage.getItem(id.toString());
			if (json) {
				const ob = JSON.parse(json);
				result = this.create(ob);
			}
		}
		if (result) {
			observable = of(result);
		} else {
			observable = of(null);
		}
		return observable;
	}
}
